// IMPORT SASS
import '../sass/style.scss';

// IMPORT JAVASCRIPT
import './_single_page_experience';
import './_autoPlay';
import './_scrollPrompt';
import './_blog-auto-show-more';
import $ from "jquery";
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
jQueryBridget( 'masonry', Masonry, $ );
import "magnific-popup"

let blogMasonry

$(window).on('load', function(){
    $('body').addClass('loaded')

    if(window.location.hash) {
        var hash = window.location.hash.substring(1);
        if(hash == 'join-us') hash = 'sp-section-9-slide-1'
        let el = $('#' + hash)

        if(el.length > 0) {
            let off = el.offset().top
            $('html, body').stop().scrollTop(off-1000)
            $('html, body').stop().animate({
                'scrollTop':   off
            }, 1800);
        }

    }
    
    $('.selected-works-grid').masonry({
        itemSelector: '.grid-item'
    });

    $('li.selected-works-years button').on('click', function(e){
        let termId = $(this).attr('data-term')
        updateSelectedWorksMenus(termId)

        handleAboutStickyNav()

        $('html,body').animate({
            scrollTop: $('#selected-works').offset().top - 40
        })
    
        e.preventDefault()
    })

    $('.selected-works-dropdown select').on('change', function(){
        let termId = $(this).val()
        updateSelectedWorksMenus(termId)
        handleAboutStickyNav()
        $('html,body').animate({
            scrollTop: $('#selected-works').offset().top - 40
        })
    })
    
    blogMasonry = $('.blog-landing-grid').masonry({
        itemSelector: '.grid-item'
    });

    handleAboutStickyNav()
})

function updateSelectedWorksMenus(activeTermId) {
    $('li.selected-works-years.active').removeClass('active')
    let activeButton = $('.selected-works-years button[data-term=' + activeTermId + ']')
    activeButton.parent().addClass('active')

    $('.selected-works-grid.active').removeClass('active')
    $('.selected-works-grid[data-term=' + activeTermId + ']').addClass('active')

    $('.selected-works-dropdown select').val(activeTermId)
}

export const appendBlogGridItems = (elements) => {
    if(blogMasonry) {
        blogMasonry.masonry("appended", elements)
    }
}

$('.selected-works-grid').each(function(){
    $(this).magnificPopup({
        type: 'image',
        delegate: 'a',
        gallery:{
            enabled:true
        }
    })
})

$('a.menu-toggle').on('click', function(e){
    $('body').toggleClass('mobile-overlay-menu-active');
    window.dispatchEvent(new Event('resize'));
    e.preventDefault();
});

$('footer #back-to-top').on('click', function(e){
    $('html, body').stop().animate({
        'scrollTop':   0
    }, 1800);
    e.preventDefault()
})

$('#nexus-areas .more').on('click', function(e){
    let parent = $(this).closest('.content')

    parent.toggleClass('opened')
    parent.find('.content-2').slideToggle(300)    

    e.preventDefault();
})

$('a[href^="#"]').on('click', function(e){
    
    const el = $(this).attr('href')
    if(el.length > 1) {
        let st = $(el).first().offset().top - $('#branding').outerHeight()
        $('html,body').stop().animate({
            'scrollTop': st
        }, 800)
        e.preventDefault()
    }
})

$('#footer .menu-columns h3').on('click', function(){
    $(this).toggleClass('mobile-opened')
})

function handleAboutStickyNav() {
    if($('#selected-works').length) {
        // make column 2 at least as tall as column 1
        $('#selected-works .column-2').css('min-height', $('#selected-works .column-1 .entry-content').outerHeight())

        // DESKTOP NAV
        let nav = $('#selected-works .column-1')
        let t = $('#selected-works').offset().top
        let l = $('#selected-works .columns').offset().left
        let scroll = $(window).scrollTop()

        let bottomOffset = t + $('#selected-works .columns').outerHeight() - $('#selected-works .column-1 .entry-content').outerHeight()
        
        // MOBILE NAV
        let mNav = $('.selected-works-dropdown')
        let mBottomOffset = t + $('#selected-works .columns').outerHeight() - mNav.outerHeight()
            
        // we've scrolled past the top of the section
        if(scroll > t - 20) {

            // DESKTOP
            // we've scrolled to the bottom
            // display the nav fixed to bottom
            if(scroll > bottomOffset) {
                nav.css({ 'position': 'absolute', 'top': 'auto', 'bottom': '-16px', 'left':0 });
            
            // display the sticky nav, fixed on top
            } else {
                nav.css({ 'position': 'fixed', 'top': '20px', 'left':l, 'z-index':9999 });
            }

            // MOBILE
            if(scroll > mBottomOffset) {
                mNav.removeClass('floating')
            } else {
                mNav.addClass('floating')
            }
        
        // display normal
        } else {
            nav.css({ 'position': 'absolute', 'top':0, 'left':0 });
            mNav.removeClass('floating')
        }
    }

}

$(window).on('scroll', handleAboutStickyNav)

$(window).on('resize', function(){
    handleAboutStickyNav()
})